<div class="form-wrapper" [class.arebic-content]="textDirection == 'rtl'" >

  <h1 class="title" translate> BUSINESS_DETAILS </h1>
  <form [formGroup]="partnerRequestForm" (ngSubmit)="onSubmit()">
    <div class="merchant-form">

      <div class="wt-100">
        <taly-custom-input [formGroup]="partnerRequestForm" [controlName]="'businessName'" id="businessName"
          label="BUSINESS_NAME" [min]="3" [max]="256" formControlName="businessName" [inputmodeType]="'text'" />
      </div>

      <div class="wt-100 signup-select-option">
        <taly-custom-select [formGroup]="partnerRequestForm" id="country" optionsLabel="{{textDirection == 'rtl' ?  'nameAr' : 'nameEn'}}"
          [controlName]="'country'" [label]="'SELECT_COUNTRY'" [options]="countries" formControlName="country"
          autoDisplayFirst="true" />
      </div>

      <div class="wt-100 signup-select-option">
        <taly-custom-select [formGroup]="partnerRequestForm" id="category" optionsLabel="{{textDirection == 'rtl' ?  'nameAr' : 'nameEn'}}"
          [controlName]="'category'" [label]="'CATERGORY'" [options]="categories" formControlName="category"
          optionsValue="nameEn" autoDisplayFirst="true" />
      </div>

      <div class="wt-100" *ngIf="isOtherIndustry">
        <taly-custom-input [formGroup]="partnerRequestForm" [controlName]="'otherIndustry'" id="otherIndustry"
          [label]="'OTHER_CATERGORY'" [min]="3" [max]="256" formControlName="otherIndustry" [inputmodeType]="'text'" />
      </div>

      <div class="wt-100 signup-select-option">
        <taly-custom-select 
          [formGroup]="partnerRequestForm"
           id="business" 
           optionsLabel="{{textDirection == 'rtl' ?  'nameAr' : 'nameEn'}}"
          [controlName]="'busines_type'" 
          [label]="'BUSINESS_TYPE'" 
          formControlName="busines_type"
          [options]="businessType" optionsValue="nameEn" />
      </div>

      <div class="d-flex">    

        <div class="w-50 signup-select-option w-40">
          <taly-custom-select [formGroup]="partnerRequestForm" id="sales" optionsLabel="{{textDirection == 'rtl' ?  'nameAr' : 'nameEn'}}"
            formControlName="annual_sales" [controlName]="'annual_sales'" [label]="'ANNUAL_SALES'"
            [options]="annulaSales" optionsValue="nameEn" />
        </div>
        <div class="w-50 signup-select-option w-40">
          <taly-custom-select [formGroup]="partnerRequestForm" id="average" optionsLabel="{{textDirection == 'rtl' ?  'nameAr' : 'nameEn'}}"
            [controlName]="'average_orders'" [label]="'AVERAGE_ORDERS'" formControlName="average_orders"
            [options]="averageOrder" optionsValue="nameEn" />
        </div>

      </div>

      <ng-container *ngIf="isNotInStore">

        <div class="title-text">
          <h4 class="title" translate>SITE_DETAILS</h4>
        </div>

        <div class="d-flex">

          <div class="w-50">
            <taly-custom-input id="webURL" [formGroup]="partnerRequestForm" [controlName]="'webURL'" label="WEB_URL"
              [inputmodeType]="'text'" formControlName="webURL" />
          </div>

          <div class="w-50 signup-select-option">
            <taly-custom-select [formGroup]="partnerRequestForm" id="platform" optionsLabel="{{textDirection == 'rtl' ?  'nameAr' : 'nameEn'}}"
              formControlName="platform" [controlName]="'platform'" [label]="'PLATFORM'" [options]="platForms"
              optionsValue="nameEn" />
          </div>

        </div>

        <div class="wt-100" *ngIf="isOtherPlatform">
          <taly-custom-input [formGroup]="partnerRequestForm" [controlName]="'otherPlatfom'" id="otherPlatfom"
            [label]="'OTHER_PLATFORM'" [min]="3" [max]="256" formControlName="otherPlatfom" [inputmodeType]="'text'" />
        </div>
      </ng-container>
      <hr>
      <div class="title-text">
        <h4 class="title" translate>CONTACT_INFO</h4>
      </div>

      <div class="d-flex">

        <div class="w-50">
          <taly-custom-input [isDisabled]="isInputNotEmpty('email')" id="email" [formGroup]="partnerRequestForm"
            [controlName]="'emailAddress'" class="email-address" label="BUSINESS_EMAIL" [inputmodeType]="'text'"
            formControlName="emailAddress" [min]="3" [max]="256" (keydown)="onKeyPress($event)" />
        </div>

        <div class="w-50">
          <taly-custom-input-group [inputmodeType]="'numeric'" class="phone-number" inputmode="numeric" [max]="8"
            [min]="8" [formGroup]="partnerRequestForm" [controlName]="'mobileNumber'" id="phone-number"
            [label]="'PHONE_NUMBER'" >
            <ng-container addonContent>
              +965
            </ng-container>
          </taly-custom-input-group>
        </div>
      </div>
      <hr>
      <div class="wt-100 last title-text">

        <h4 class="title" translate> ANYTHING </h4>

        <taly-custom-textarea [formGroup]="partnerRequestForm" [controlName]="'comments'" id="anything-else"
          label="ANYTHING" [min]="3" [max]="256" formControlName="comments" [inputmodeType]="'text'" />


      </div>

      <div class="button-wrapper">

        <div class="label">
          <label translate>TERM_ACCEPTING</label>
          <span class="link" translate (click)="showDialog(true)"> TERM_OF_USE </span> <span translate>AND</span>
          <span class="link" translate (click)="showDialog(false)"> PRIVACY_POLICY </span>
        </div>

        <button class="btn btn-sky-blue wt-100" type="submit" translate [disabled]="partnerRequestForm.invalid">
          SUBMIT
        </button>

      </div>
    </div>
  </form>

</div>

<div>


</div>
<p-dialog [draggable]="false" dir="ltr" header="Terms of Use" [style]="{height: ''}" [modal]="true"
  [(visible)]="displayDialog" [style]="{width: '646px'}" [baseZIndex]="10000">
  <ng-template pTemplate="header">
    <h4> {{ isTermOfUse ? ('TERM_OF_USE' | translate) : ('PRIVACY_POLICY' | translate) }} </h4>
    <!-- <img class="close-logo" src="assets/images/close-icon.svg" alt=""> -->
  </ng-template>
  <ng-template pTemplate="content">

    <ng-container *ngIf="isTermOfUse; else privacyPolicy">
      <taly-terms-of-use [showHeader]="true" />
    </ng-container>
    <ng-template #privacyPolicy>
      <taly-privacy-policy />
    </ng-template>


  </ng-template>
</p-dialog>